import { useContext} from 'react'
import ProgressCard from './ProgressCard.jsx';
import { SubscriptionContext } from '../../../contextApi/SubscriptionContext.jsx';

export default function Progress() {
    const {progressState} = useContext(SubscriptionContext);
    const deployP=()=>{
        const phases = ["יצירת משתמש","יצירת האתר","תשלום"];
        return phases.map((p, inx)=>{
            return inx < 2 ? <div key={`progressCard_num_${inx}_div`} className='progressDotsDiv'>
                <ProgressCard key={`progressCard_num_${inx}`} phaseName={p} phaseValue={inx+1} progressState={progressState}/>
                <div className='progressDot'></div>
                <div className='progressDot'></div>
                <div className='progressDot'></div>
                <div className='progressDot'></div>
                <div className='progressDot'></div>
            </div> :
            <ProgressCard key={`progressCard_num_${inx}_state_${progressState}`} phaseName={p} phaseValue={inx+1} progressState={progressState}/>
        })
    }
  return (
    <div key={`progress_state_${progressState}`} className='progress'>
        {deployP()}
    </div>
  )
}
